<script lang="ts">
  // The page Puppeteer screenshots (resources/views/social_reports/render.blade.php). Adds
  // #report_ready_flag once fonts and images have loaded.
  import { onMount, tick } from 'svelte'
  import ReportCanvas from './ReportCanvas.svelte'
  import { sizeOf } from './context'
  import { reportFontsLoaded } from './fonts'
  import type { ReportData, ReportOptions } from './types'

  export let data: ReportData
  export let templateId: string
  export let options: Partial<ReportOptions> | null = null

  $: dims = sizeOf(options)

  let root: HTMLElement
  let ready = false

  function imageLoaded(img: HTMLImageElement): Promise<void> {
    if (img.complete) return Promise.resolve()
    return new Promise((resolve) => {
      img.addEventListener('load', () => resolve(), { once: true })
      img.addEventListener('error', () => resolve(), { once: true })
    })
  }

  onMount(async () => {
    await tick()
    // Fill components measure their space before drawing; give them a frame.
    await new Promise((r) => requestAnimationFrame(() => r(null)))
    await tick()
    const timeout = new Promise((r) => setTimeout(r, 15000))
    await Promise.race([
      Promise.all([reportFontsLoaded(), ...Array.from(root.querySelectorAll('img')).map(imageLoaded)]),
      timeout,
    ])
    ready = true
  })
</script>

<div id="social-report" bind:this={root} style="width: {dims.width}px; height: {dims.height}px; overflow: hidden;">
  <ReportCanvas {data} {templateId} {options} />
</div>
{#if ready}<div id="report_ready_flag" />{/if}
